import { render } from "./Heatmap.vue?vue&type=template&id=330cf2c0&scoped=true"
import script from "./Heatmap.vue?vue&type=script&lang=js"
export * from "./Heatmap.vue?vue&type=script&lang=js"

import "./Heatmap.vue?vue&type=style&index=0&id=330cf2c0&scoped=true&lang=css"

import exportComponent from "/var/www/share/bb5.highdigital.de/vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-330cf2c0"]])

export default __exports__